import React, {useContext, MouseEventHandler} from 'react'
import {Props as ReportsSpreadsheetColumnProps} from './Column'

export type ReportsSpreadsheetContextProps = {
  prefix: string
  columns: ReportsSpreadsheetColumnProps[]
  data: any[]
  sort: string
  onSort: (sort: string) => any
  onNewColumn?: MouseEventHandler<any>
}

const ReportsSpreadsheetContext = React.createContext<ReportsSpreadsheetContextProps>(null as any)

export default ReportsSpreadsheetContext

export function useReportsSpreadsheetContext() {
  return useContext(ReportsSpreadsheetContext)
}
